'use client'
import { useAgentPortfolio } from '@repo/services'
import { PaymentType } from '@repo/shared/components'
import { useTranslate } from '@repo/shared/hooks'
import { Col, Typography } from '@repo/ui/components'
import { cn } from '@repo/ui/lib'
import { useMemo } from 'react'

export const DashboardAgentsWalletHeader = ({
  isDesktop,
}: {
  isDesktop: boolean
}) => {
  const { t } = useTranslate()

  const { data: { data: { accounts } = {} } = {} } = useAgentPortfolio()
  const account = useMemo(() => {
    return accounts?.find((account) => account.type === 'fiat')
  }, [accounts])

  return (
    <Col
      className={cn(
        !isDesktop ? 'dark bg-neutral-surface-dark' : '',
        'max-w-[720px] gap-xs items-center pb-md md:pb-0',
      )}
    >
      <Typography size='sm' color='text-neutral-surface-100'>
        {t('walletPage_balance')}
      </Typography>
      <PaymentType
        value={account?.availableBalance}
        numberSize='2xl'
        size='sm'
        isBold={true}
      />
    </Col>
  )
}
